import { match } from 'ts-pattern';
import { AccessLevel, UserType } from '@ps/core-models';
import { User } from '../models/user.model';

const SERVICE_OPERATOR_LEVELS = new Set<AccessLevel>([
  'serviceOperator',
  'admin',
]);

export const getUserType = (user: User): UserType => {
  return match(user)
    .when(
      ({ operatorAccessLevel }) => operatorAccessLevel !== 'none',
      () => 'operator',
    )
    .when(
      ({ buyerAccessLevel }) => buyerAccessLevel !== 'none',
      () => 'buyer',
    )
    .when(
      ({ supplierAccessLevel }) => supplierAccessLevel !== 'none',
      () => 'supplier',
    )
    .otherwise(() => 'none') as UserType;
};

export const isMultiBuyerUser = ({ buyerAccessLevel }: User): boolean => {
  return (
    buyerAccessLevel === 'multiBuyer' || buyerAccessLevel === 'masterMultiBuyer'
  );
};

export const isBuyerUser = (user: User): boolean =>
  getUserType(user) === 'buyer';

export const getUserAccessLevel = (
  user: User,
  userType: UserType,
): AccessLevel => {
  return match(userType)
    .with('operator', () => user.operatorAccessLevel)
    .with('buyer', () => user.buyerAccessLevel)
    .with('supplier', () => user.supplierAccessLevel)
    .otherwise(() => 'none') as AccessLevel;
};

export const hasServiceOperatorAccessLevel = (
  user: User,
  userType: UserType,
): boolean => {
  if (userType !== 'operator') return false;

  const userAccessLevel = getUserAccessLevel(user, userType);
  return SERVICE_OPERATOR_LEVELS.has(userAccessLevel);
};
